import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ServiceTask } from './service-task';
export { ServiceTask };
import { serviceTaskSchema } from '@schemas/business-objects/service-task';
import { ServiceTaskHistoryFormArray } from './service-task-history-form-group';
import { TokenFormArray, TokenFormGroup } from './token-form-group';

export class ServiceTaskFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    referenceNumber: SchemaFormControl;
    name: SchemaFormControl;
    queue: SchemaFormControl;
    status: SchemaFormControl;
    attempts: SchemaFormControl;
    claimedBy: SchemaFormControl;
    claimedAt: SchemaFormControl;
    errorMessage: SchemaFormControl;
    data: SchemaFormControl;
    completedAt: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    tokenId: SchemaFormControl;
    token: TokenFormGroup;
    tokens: TokenFormArray;
    serviceTaskHistories: ServiceTaskHistoryFormArray;
  };

  declare value: Partial<ServiceTask>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(serviceTaskSchema, ServiceTask, data, options);
  }

  get object(): ServiceTask {
    return new ServiceTask(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'token':
        return new TokenFormGroup();
      case 'tokens':
        return new TokenFormArray();
      case 'serviceTaskHistories':
        return new ServiceTaskHistoryFormArray();
      default:
        return undefined;
    }
  }

  async fail(options: any): Promise<any> {
    const instance = new ServiceTask(this.value);
    return instance.fail(options);
  }

  async error(options: any): Promise<any> {
    const instance = new ServiceTask(this.value);
    return instance.error(options);
  }

  async complete(options: any): Promise<any> {
    const instance = new ServiceTask(this.value);
    return instance.complete(options);
  }

  async claim(options: any): Promise<any> {
    const instance = new ServiceTask(this.value);
    return instance.claim(options);
  }
}

export class ServiceTaskFormArray extends PersistedFormArray {
  readonly entityName = 'ServiceTask' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(serviceTaskSchema, ServiceTask, options);
  }

  protected override createItemGroup() {
    return new ServiceTaskFormGroup();
  }

  get array(): ServiceTask[] {
    return this.controls.map((group: ServiceTaskFormGroup) => group.object);
  }
}

export class ServiceTaskPersistedArray extends PersistedArray<ServiceTask> {
  readonly entityName = 'ServiceTask' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ServiceTask, options);
  }
}
